import React from 'react';
import QuickActionCard from './QuickActionCard';

const ClaimsOfficerActions = ({ userRoles }) => {
  // Only render for Claims Officers - Early return for performance
  if (!userRoles.includes('Claims_Officer')) {
    return null;
  }

  return (
    <>
      <QuickActionCard
        to="/claims?status=SUBMITTED"
        title="Review Claims"
        description="Review newly submitted claims awaiting assignment"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        }
        iconColor="text-claims-officer-600"
        hoverIconColor="group-hover:text-claims-officer-700"
        titleHoverColor="group-hover:text-claims-officer-700"
        badge="pending"
      />

      <QuickActionCard
        to="/claims?status=UNDER_REVIEW&assignedToMe=true"
        title="My Claims"
        description="Claims currently assigned to me for review"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        }
        iconColor="text-claims-officer-600"
        hoverIconColor="group-hover:text-claims-officer-700"
        titleHoverColor="group-hover:text-claims-officer-700"
        badge="active"
      />

      <QuickActionCard
        to="/claims?status=MISSING_DOCUMENTS"
        title="Pending Documents"
        description="Claims waiting for additional documentation"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        }
        iconColor="text-process-600"
        hoverIconColor="group-hover:text-process-700"
        titleHoverColor="group-hover:text-process-700"
        badge="documents"
      />

      <QuickActionCard
        to="/sla-dashboard"
        title="SLA Monitoring"
        description="Monitor service level agreements and compliance metrics"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        }
        iconColor="text-orange-600"
        hoverIconColor="group-hover:text-orange-700"
        titleHoverColor="group-hover:text-orange-700"
        badge="sla"
      />
    </>
  );
};

export default React.memo(ClaimsOfficerActions);
